import React from "react";
import T from "prop-types";
import { TENANT_LOCATION } from "MODULES/shared/components/ShippingSection/shippingTypes";
import { DO_NOT_SHIP } from "MODULES/PurchaseOrders/constants";
import { NoteTooltip as IconTooltip } from "MODULES/shared/components";

export function DropshipIcon({
  className = "",
  createdAt,
  exporting,
  shippingType
}) {
  if ([TENANT_LOCATION, DO_NOT_SHIP].includes(shippingType)) return null;

  const domesticFeatureActive = new Date(2024, 9, 31) < new Date(createdAt);

  if (!exporting || !domesticFeatureActive) {
    return (
      <span style={{ position: "absolute", left: "-21px", top: "8px" }}>
        <IconTooltip
          url="https://info-trader-assets.s3.us-east-2.amazonaws.com/icons/dropship.png"
          note={domesticFeatureActive ? "Domestic Dropship" : "Dropship"}
          placement="top"
          className={className}
        />
      </span>
    );
  }

  return (
    <span style={{ position: "absolute", left: "-21px", top: "8px" }}>
      <IconTooltip
        icon="fa-globe"
        note="International Dropship"
        placement="top"
        color="white"
        className={className}
      />
    </span>
  );
}
DropshipIcon.propTypes = {
  className: T.string,
  shippingType: T.string
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/DropshipIcon.jsx